import React, { FC } from "react";
import { FormControl, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { useIntl } from "react-intl";

import { SortDirection } from "@framework/types-collection";

import { SortButton } from "../../../../../../../../components/common/buttons/sort-button";
import { StationTrainSortField } from "./station-train-sort";

const SORT_FIELD_MESSAGE_IDS: Record<StationTrainSortField, string> = {
  [StationTrainSortField.custom]: "pages.scheme.stationTile.sort.custom",
  [StationTrainSortField.name]: "pages.scheme.stationTile.sort.name",
  [StationTrainSortField.alarmStatus]: "pages.scheme.stationTile.sort.alarmStatus",
  [StationTrainSortField.tci]: "pages.scheme.stationTile.sort.tci",
  [StationTrainSortField.mode]: "pages.scheme.stationTile.sort.mode",
  [StationTrainSortField.forecast]: "pages.scheme.stationTile.sort.forecast",
};

const SORT_FIELDS = Object.values(StationTrainSortField);

export interface IStationTrainSortToolbarProps {
  direction: SortDirection;
  field: StationTrainSortField;
  onDirectionChange: () => void;
  onFieldChange: (field: StationTrainSortField) => void;
}

export const StationTrainSortToolbar: FC<IStationTrainSortToolbarProps> = ({
  direction,
  field,
  onDirectionChange,
  onFieldChange,
}) => {
  const { formatMessage } = useIntl();

  const handleFieldChange = (event: SelectChangeEvent<StationTrainSortField>) => {
    onFieldChange(event.target.value as StationTrainSortField);
  };

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth: 0 }}>
      <FormControl size="small" sx={{ minWidth: 220, maxWidth: "100%" }}>
        <Select
          value={field}
          onChange={handleFieldChange}
          displayEmpty
          sx={{
            fontSize: 13,
            height: 32,
            "& .MuiSelect-select": {
              py: 0.75,
            },
          }}
        >
          {SORT_FIELDS.map(sortField => (
            <MenuItem key={sortField} value={sortField} sx={{ fontSize: 13 }}>
              {formatMessage({ id: SORT_FIELD_MESSAGE_IDS[sortField] })}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SortButton direction={direction} isActive onClick={onDirectionChange} width={18} height={18} />
    </Stack>
  );
};
